// Copyright Epic Games, Inc. All Rights Reserved.

import { Selector } from "react-redux";
import { IAppState } from "../index";
import {
  IInstallationGroupProgressMessage,
  IInstallationProgress,
} from "../../services/EOSHelperAPI";
import { installationFeatureStoreKey } from "./reducer";

export const selectInstallationGroupProgress: Selector<
  IAppState,
  IInstallationGroupProgressMessage
> = (state: IAppState) => state[installationFeatureStoreKey].progress;

export const selectInstallationProgress: Selector<
  IAppState,
  IInstallationProgress
> = (state: IAppState) =>
  state[installationFeatureStoreKey].progress.currentTaskProgress;

export const selectInstallationGroupId: Selector<IAppState, string> = (
  state: IAppState
) => state[installationFeatureStoreKey].groupId;

export const selectInstallationCancelling: Selector<IAppState, boolean> = (
  state: IAppState
) => state[installationFeatureStoreKey].cancellingInstallation;

export const selectInstallationErrorCode: Selector<IAppState, string> = (
  state: IAppState
) => state[installationFeatureStoreKey].errorCode;

export const selectInstallationPulledMetadataFlag: Selector<
  IAppState,
  boolean
> = (state: IAppState) => {
  return state[installationFeatureStoreKey].pulledMetadata;
};
